module.exports = __webpack_public_path__ + "static/img/CircleBrands.97459adf.svg";